import React, { useState, useEffect } from 'react';
import { Container,  Grow } from '@material-ui/core';
import { useDispatch } from 'react-redux';

import Posts from './components/Posts/Posts';
import { getPosts } from './actions/posts';

const App = () => {
  const [currentId, setCurrentId] = useState(0);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPosts());
  }, [currentId, dispatch]);

  return (
    <Container maxWidth="lg" >
      <Grow in>
        <Container>
              <Posts setCurrentId={setCurrentId} />
        </Container>
      </Grow>
    </Container>
  );
};

export default App;
